import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';

import type { Color } from '@opendoor/tokens-studio/dist/bricks-next/types/Novo';
import { getToken } from '@tamagui/core';

type BricksSvgProps = Omit<SvgProps, 'width' | 'height' | 'color'> & {
  size?: 20 | 24,
  color?: Color,
};
const SvgCheckmark = ({ size = 24, color = '$contentPrimary', ...inProps }: BricksSvgProps) => {
  const outProps: SvgProps = {};
  if (size) {
    outProps.width = size;
    outProps.height = size;
  }
  if (color) {
    const colorToken = getToken(color, 'color');
    outProps.color = colorToken;
  }
  const props = {
    viewBox: '0 0 24 24',
    ...inProps,
    ...outProps,
  };
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
      <Path
        fill="currentColor"
        d="m9.218 15.319 9.967-9.966Q19.537 5 20.022 5q.486 0 .838.353.354.352.353.838 0 .484-.353.838L10.042 17.847q-.354.353-.824.353t-.823-.353L3.34 12.791A1.1 1.1 0 0 1 3 11.953a1.2 1.2 0 0 1 .367-.838q.353-.353.838-.353t.838.353z"
      />
    </Svg>
  );
};
export default SvgCheckmark;
